import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';

import { environment } from 'environments/environment';
import { NotificationType } from '../enums/notification-type.enum';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { LineUpProNotification } from '../DTOs/lineupProNotification';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class NotificationService {

    private subject = new Subject<LineUpProNotification>();
    private pinToRoute = false;

    constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient) {
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.pinToRoute) {
                    this.pinToRoute = false;
                } else {
                    this.clearNotification();
                }
            }
        });
    }

    getNotification(): Observable<any> {
        return this.subject.asObservable();
    }

    toNotify(message: string, options?: any, pinToScreen: boolean = true, pinToRoute: boolean = true, type: NotificationType = NotificationType.DEFAULT) {

        //if (!environment.production) {
            switch (type) {
                case NotificationType.ERROR:
                    console.groupCollapsed('Notificação de Erro');
                    console.log('Uma notificação de erro foi emitida por', this.router.url);
                    console.trace(message);
                    console.groupEnd();
                    break;
                case NotificationType.SUCCESS:
                    console.groupCollapsed('Notificação de Sucesso');
                    console.log('Uma notificação de sucesso foi emitida por', this.router.url);
                    console.log(message);
                    console.groupEnd();
                    break;
                default:
                    console.groupCollapsed('Notificação Padrão');
                    console.log('Uma notificação foi emitida por', this.router.url);
                    console.log(message);
                    console.groupEnd();
                    break;
            }
        //}

        this.pinToRoute = pinToRoute;

        const _options: MatSnackBarConfig = { panelClass: 'snackbar-generico', verticalPosition: 'bottom', horizontalPosition: 'right' };
        if (!pinToScreen) { _options.duration = 4000; }

        Object.assign(_options, options);

        if (message.length > 200) {
          message = message.substring(0, 197) + '...';
        }

        this.subject.next(<LineUpProNotification>{ message: message, pinned: pinToScreen, options: _options});
    }

    toNotifyInfo(message: string, options?: any, pinToScreen: boolean = true, pinToRoute: boolean = false, messageBotao = '') {
        const _options: any = { panelClass: 'snackbar-info' };
        Object.assign(_options, options);

        if (Array.isArray(message['errors'])) {
            message = message['errors'][0]
        }

        this.toNotify(message, _options, pinToScreen, pinToRoute, NotificationType.INFO);
    }

    toNotifySucess(message: string, options?: any, pinToScreen: boolean = false, pinToRoute: boolean = false, messageBotao = '') { 
        const _options: any = { panelClass: 'snackbar-sucess' };
        Object.assign(_options, options);

        this.toNotify(message, _options, pinToScreen, pinToRoute, NotificationType.SUCCESS);
    }

    toNotifyError(message: string, options?: any, pinToScreen: boolean = true, pinToRoute: boolean = false, messageBotao = '') {
        const _options: any = { panelClass: 'snackbar-error' };
        Object.assign(_options, options);

        if (Array.isArray(message['errors'])) {
            message = message['errors'][0]
        }

        this.toNotify(message, _options, pinToScreen, pinToRoute, NotificationType.ERROR);
    }

    clearNotification() {
        this.subject.next(null);
    }

    save(body): Observable<any> {
        return this.http.post<any>(`${environment.apis.lineupUrl}notification/v1/settings`, body);
    }

    update(body): Observable<any> {
        return this.http.put<any>(`${environment.apis.lineupUrl}notification/v1/settings`, body);
    }

    getSettings() {
        return this.http.get<any>(`${environment.apis.lineupUrl}notification/v1/settings`);
    }

}
